import React from 'react'
import { Text, View } from 'react-native'
import { layout, typography } from './tokens'

// The standard confidentiality line every sharing site shows (World 50 Design
// Guidelines v2.0). Always the current year, deliberately: leadership wants
// doclets to never look stale, matching legacy.
const DocletFooter = () => (
  <View
    style={{
      width: '100%',
      maxWidth: layout.pageMaxWidth,
      paddingVertical: 8
    }}
  >
    <Text style={typography.footer}>
      Confidential © World 50 Group, Inc. {new Date().getFullYear()}
    </Text>
  </View>
)

export default DocletFooter
